import React, { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SERVICE_CODE } from "../constants";

const isHanaWebExitPath = (path) => {
  const webExitPages = [
    "/hana-main",
    "/certification/error",
    "/certification/error-guide",
    "/certification/start",
  ];
  return webExitPages.includes(path);
};

const CommonHeader = () => {
  const previousPath = useRef("");
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const { pathname, search } = location;
    const serviceCode = new URLSearchParams(search).get("serviceCode") || "";

    if (
      pathname.includes("/certification") ||
      serviceCode === SERVICE_CODE.HANA
    ) {
      previousPath.current = location.pathname;
      window.historyBack = () => {
        if (isHanaWebExitPath(previousPath.current)) {
          window.location.href = "WEB_EXIT_EVENT";
        } else {
          history.goBack();
        }
      };
    }

    history.listen((location, action) => {
      if (action === "POP" && isHanaWebExitPath(previousPath.current)) {
        window.location.href = "WEB_EXIT_EVENT";
        history.push(previousPath.current);
      }
      previousPath.current = location.pathname;
    });
  }, []);

  return <></>;
};

export default CommonHeader;
